<template>
  <div class="box-type01">
    <div class="join-box">
      <i class="far fa-check-circle" aria-hidden="true"></i>
      <div class="entry-txt01 mgt30"><span>[{{props.mberNm}}]</span>님의 아이디<br><br>
        <p v-for="mberId in mberIds"
           :key="mberId">{{ mberId }}</p>
      </div>
      <div class="entry-txt02 mgt60">로그인 후 세로이의 다양한 서비스를 이용하세요.</div>
    </div>
  </div>
  <div class="layer-btn">
    <btn :txt="'비밀번호 찾기'"
         :color="'gray'"
         @click="btnPswdFind_click"/>
    <btn :txt="'로그인'"
         :color="'purple'"
         @click="btnLgin_click"/>
  </div>
</template>

<script setup>
import {defineProps, defineEmits} from "vue";

const props = defineProps({
  mberNm: {
    type: String,
    required: true
  },
  mberIds: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emits = defineEmits(['chng-tab', 'close']);
const btnPswdFind_click = () => {
  emits('chng-tab');
}

const btnLgin_click = () => {
  emits('close');
}
</script>

<style scoped>

</style>